<template>
  <div class="content">
    <el-empty :image="img" :image-size="223" description="暂无权限！">
      <!-- <div style="font-size: 14px;color: #909399;margin-bottom:20px">客服电话：029-66666666</div>
      <el-button type="primary" size="mini">立即续费</el-button> -->
    </el-empty>
  </div>
</template>
<script>
var img = 'https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/stateImg/permission_pc.png'
import Store from '@/store/index'
export default {
  data() {
    return {
      img: img
    }
  },
  mounted() {
    Store.commit('user/setLoading', false)
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/index.scss';
.content{
  width: 83%;
  height: 63%;
  background: $color_white;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-button--mini {
  padding: 2px 14px;
  border-radius: 4px;
}
</style>
